export const BACKEND_DATE_FORMAT = 'YYYY-MM-DD';
